<nb-card style="height: 100%;">
  <nb-card-header>
    <h2>Word List</h2>
    <button mat-button style="color: #89051f; padding: 0px;" (click)="addWordClicked();">
      <fa-icon [icon]="faPlusCircle" size="lg"></fa-icon>
      New Dictionary
    </button>
  </nb-card-header>
  <nb-card-body>
    <nb-card class="editForm" [class.active]="editActive" style="overflow: hidden;">
      <nb-card-header>
        <div class="row">
          <div class="col">
            <h2 *ngIf="editWord.id === undefined">Create Dictionary</h2>
            <h2 *ngIf="editWord.id !== undefined">Edit Dictionary for {{editWord.originalWord}}</h2>
          </div>
          <div class="col" style="text-align: right; color: crimson;" *ngIf="wordId !== 0">
            <button mat-icon-button (click)="deleteWordClicked();"><i class="fas fa-trash-alt fa-2x"></i></button>
          </div>
        </div>
      </nb-card-header>
      <nb-card-body [nbSpinner]="wordLoading">
        <form #WordForm="ngForm" id="WordForm" name="WordForm" style="margin-top: 15px;">
          <div class="row">
            <div class="form-group col-sm-4">
              <h3>Details</h3>
              <div class="kw-input">
                <label for="originalWord">Original Word</label>
                <input type="text" class="form-control" id="originalWord" name="originalWord" required
                  [(ngModel)]="editWord.originalWord" #originalWord="ngModel">
                <div [hidden]="originalWord.valid || originalWord.pristine" class="alert alert-danger">
                  Original is required
                </div>
              </div>
              <div class="kw-input">
                <label for="replacementWord">Replacement Word</label>
                <input type="text" class="form-control" id="replacementWord" name="replacementWord" required
                  [(ngModel)]="editWord.replacementWord" #replacementWord="ngModel">
                <div [hidden]="replacementWord.valid || replacementWord.pristine" class="alert alert-danger">
                  Replacement word is required
                </div>
              </div>
              <div class="kw-input">
                <label for="isActive">Is Active: </label>
                <mat-checkbox class="isActiveCheck" name="isActive" matInput [checked]="false" type="checkbox"
                  [(ngModel)]="editWord.isActive" #isActive="ngModel" color="primary"></mat-checkbox>
              </div>
            </div>
          </div>
        </form>
      </nb-card-body>
      <nb-card-footer class="row" style="margin-top: 10px;">
        <div [nbSpinner]="submitting" class="col-md-auto d-flex align-items-center">
          <button *ngIf="!submitting" type="submit" form="WordForm" mat-raised-button color="primary"
            (click)="saveWordClicked();">Save</button>
        </div>
        <div class="col d-flex align-items-center justify-content-start" (click)="cancelClicked();">
          <a>Cancel</a>
        </div>
      </nb-card-footer>
    </nb-card>

    <div class="mat-elevation-z2">
      <table mat-table class="full-width-table" [dataSource]="dataSource" matSort aria-label="Elements">
        <!-- Id Column -->
        <ng-container matColumnDef="id">
          <th class="tableHeader" mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
          <td mat-cell *matCellDef="let row">{{row.id}}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="originalWord">
          <th class="tableHeader" mat-header-cell *matHeaderCellDef mat-sort-header>Original Word</th>
          <td mat-cell *matCellDef="let row">{{row.originalWord}}</td>
        </ng-container>
        <ng-container matColumnDef="replacementWord">
          <th class="tableHeader" mat-header-cell *matHeaderCellDef mat-sort-header>Replacement Word</th>
          <td mat-cell *matCellDef="let row">{{row.replacementWord}}</td>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <th class="tableHeader" mat-header-cell *matHeaderCellDef mat-sort-header>Is Active</th>
          <td mat-cell *matCellDef="let row">
            <div *ngIf="row.isActive === true" style="color: green;">
              <fa-icon [icon]="faCheck"></fa-icon>
            </div>
            <div *ngIf="row.isActive === false" style="color: darkRed">
              <fa-icon [icon]="faTimes"></fa-icon>
            </div>
          </td>
        </ng-container>
        <!-- Edit Column -->
        <ng-container matColumnDef="edit">
          <th class="tableHeader" mat-header-cell *matHeaderCellDef mat-sort-header>Edit</th>
          <td mat-cell *matCellDef="let row"><button mat-icon-button (click)="editClicked(row.id);"><i
                class="fas fa-edit fa-lg"></i></button></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="50"
        [pageSizeOptions]="[25, 50, 100, 250]">
      </mat-paginator>
    </div>
  </nb-card-body>
</nb-card>